/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PairWatchSnapshot interface.
 */
export function instanceOfPairWatchSnapshot(value) {
    if (!('g' in value) || value['g'] === undefined)
        return false;
    if (!('gCrit' in value) || value['gCrit'] === undefined)
        return false;
    if (!('l' in value) || value['l'] === undefined)
        return false;
    if (!('baselineLevel' in value) || value['baselineLevel'] === undefined)
        return false;
    if (!('country' in value) || value['country'] === undefined)
        return false;
    if (!('lam' in value) || value['lam'] === undefined)
        return false;
    if (!('mu' in value) || value['mu'] === undefined)
        return false;
    if (!('pLow' in value) || value['pLow'] === undefined)
        return false;
    if (!('pairId' in value) || value['pairId'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('verdict' in value) || value['verdict'] === undefined)
        return false;
    if (!('window' in value) || value['window'] === undefined)
        return false;
    return true;
}
export function PairWatchSnapshotFromJSON(json) {
    return PairWatchSnapshotFromJSONTyped(json, false);
}
export function PairWatchSnapshotFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'g': json['G'],
        'gCrit': json['G_crit'],
        'l': json['L'],
        'baselineLevel': json['baseline_level'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'country': json['country'],
        'lam': json['lam'],
        'mu': json['mu'],
        'pLow': json['p_low'],
        'pairId': json['pair_id'],
        'updatedAt': json['updated_at'],
        'verdict': json['verdict'],
        'window': json['window'],
    };
}
export function PairWatchSnapshotToJSON(json) {
    return PairWatchSnapshotToJSONTyped(json, false);
}
export function PairWatchSnapshotToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'G': value['g'],
        'G_crit': value['gCrit'],
        'L': value['l'],
        'baseline_level': value['baselineLevel'],
        'brand': value['brand'],
        'country': value['country'],
        'lam': value['lam'],
        'mu': value['mu'],
        'p_low': value['pLow'],
        'pair_id': value['pairId'],
        'updated_at': value['updatedAt'],
        'verdict': value['verdict'],
        'window': value['window'],
    };
}
